module.exports = __webpack_public_path__ + "img/美赞臣.7c1d42a7.png";